
import { handleApiError } from "../CommonFunctions";
import * as constants from "../Constatnts";
import axios from "axios";


export function addNewVendor(vendor) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.post(
        `${constants.API_URL}/vendor`,
        vendor,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if(response.data.code=="0"){
           return response.data.vendorId;
      }
      else{
alert(response.data.message || "failed to save bednor")
return null;
      }
   
    } catch (error) {
      handleApiError(error);
      return null;
    }
  };
}


export function getVendors(
  from = 0,
  size = 25,
  option = "",
  searchText = "",
  name = "",
  lastname = "",
  PhoneNo = "",
  EmailID = "",
  searchCity = "",
  searchState = "",
  searchCountry = "",
  searchPinCode = "",
  searchCustomField1 = "",
  searchCustomField2 = "",
  searchCustomField3 = "",
  searchCustomField4 = "",
  searchCustomField5 = "",
  searchCustomField6 = "",
  filterByVendorCode = ""
) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      let apiUrl = "/vendor/filter";
      let queryParams = [];

      if (filterByVendorCode) {
        queryParams.push(`filterByVendorCode=${encodeURIComponent(filterByVendorCode)}`);
      }
      if (from !== undefined) {
        queryParams.push(`from=${from}`);
      }
      if (size !== undefined) {
        queryParams.push(`size=${size}`);
      }
      if (option) {
        queryParams.push(`option=${encodeURIComponent(option)}`);
      }
      if (searchText) {
        queryParams.push(`searchText=${encodeURIComponent(searchText)}`);
      }
      if (name) {
        queryParams.push(`name=${encodeURIComponent(name)}`);
      }
      if (lastname) {
        queryParams.push(`lastname=${encodeURIComponent(lastname)}`);
      }
      if (PhoneNo) {
        queryParams.push(`PhoneNo=${encodeURIComponent(PhoneNo)}`);
      }
      if (EmailID) {
        queryParams.push(`EmailID=${encodeURIComponent(EmailID)}`);
      }
      if (searchCity) {
        queryParams.push(`searchCity=${encodeURIComponent(searchCity)}`);
      }
      if (searchState) {
        queryParams.push(`searchState=${encodeURIComponent(searchState)}`);
      }
      if (searchCountry) {
        queryParams.push(`searchCountry=${encodeURIComponent(searchCountry)}`);
      }
      if (searchPinCode) {
        queryParams.push(`searchPinCode=${encodeURIComponent(searchPinCode)}`);
      }
      if (searchCustomField1) {
        queryParams.push(`searchCustomField1=${encodeURIComponent(searchCustomField1)}`);
      }
      if (searchCustomField2) {
        queryParams.push(`searchCustomField2=${encodeURIComponent(searchCustomField2)}`);
      }
      if (searchCustomField3) {
        queryParams.push(`searchCustomField3=${encodeURIComponent(searchCustomField3)}`);
      }
      if (searchCustomField4) {
        queryParams.push(`searchCustomField4=${encodeURIComponent(searchCustomField4)}`);
      }
      if (searchCustomField5) {
        queryParams.push(`searchCustomField5=${encodeURIComponent(searchCustomField5)}`);
      }
      if (searchCustomField6) {
        queryParams.push(`searchCustomField6=${encodeURIComponent(searchCustomField6)}`);
      }

      if (queryParams.length > 0) {
        apiUrl += `?${queryParams.join("&")}`;
      }

      const response = await axios.get(constants.API_URL + apiUrl, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      let vendors = [];
      let filteredVendors = [];

      if (response && response.data && response.data.vendors) {
        vendors = response.data.vendors;
      }

    vendors.forEach((data) => {
  let party = data;

  if (getState().user.user.Role === "Power User") {
    filteredVendors.push({ key: data._id, ...party });
  } else if (
    party.hasOwnProperty("StoreID") &&
    party.StoreID &&
    party.StoreID.trim() !== "" &&
    party.StoreID === getState().user.store.key
  ) {
    filteredVendors.push({ key: data._id, ...party });
  } else if (
    party.hasOwnProperty("AssociatedStores") &&
    Array.isArray(party.AssociatedStores) &&
    party.AssociatedStores.some(
      (f) => f.StoreID === getState().user.store.key
    )
  ) {
    filteredVendors.push({ key: data._id, ...party });
  }
});

      return {
        totalItemsCount: response.data.totalCount,
        searchResult: filteredVendors,
      };
    } catch (error) {
  if (
    error &&
    error.hasOwnProperty("response") &&
    error.response &&
    error.response.hasOwnProperty("data")
  ) {
    throw error.response.data;
  }

  throw error;
    }
  };
}



export function deleteVendor(key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.delete(
        constants.API_URL + `/vendor/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.code === "0") {
        return true;
      } else {
        alert(response.data.message || "Failed to delete vendor");
        return false;
      }

    } catch (error) {
      alert("Failed to delete vendor");
      return false;
    }
  };
}

export function getVendorDetails(id) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.get(
        `${constants.API_URL}/vendor/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const { key, ...vendor } = response.data.vendor;

      return vendor;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

export function updateVendor(vendor, key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.put(
        `${constants.API_URL}/vendor/${key}`,
        vendor,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    if(response.data.code=="0"){
      return true
    }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}




export function searchVendor(RegistrationID, StoreID, searchText) {
  return async (dispatch, getState) => {
    try {
      const from = 0;
      const size = 50;
      const option = "active";
      const token = getState().user.uat;

      let apiUrl = "/vendor/filter";
      const queryParams = [];

      queryParams.push(`from=${from}`);
      queryParams.push(`size=${size}`);
      queryParams.push(`option=${encodeURIComponent(option)}`);

      if (searchText) {
        queryParams.push(
          `searchText=${encodeURIComponent(searchText)}`
        );
      }

      apiUrl += `?${queryParams.join("&")}`;

      const response = await axios.get(
        constants.API_URL + apiUrl,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      let vendors = [];
      let filteredVendors = [];

      if (
        response &&
        response.hasOwnProperty("data") &&
        response.data &&
        response.data.hasOwnProperty("vendors")
      ) {
        vendors = response.data.vendors;
      }

      vendors.forEach((data) => {
        let party = data;

        if (
          party &&
          party.hasOwnProperty("StoreID") &&
          party.StoreID &&
          party.StoreID === StoreID
        ) {
          filteredVendors.push({
            key: data._id,
            ...party,
          });
        } else if (
          party &&
          party.hasOwnProperty("AssociatedStores") &&
          Array.isArray(party.AssociatedStores) &&
          party.AssociatedStores.some(
            (store) =>
              store &&
              store.hasOwnProperty("StoreID") &&
              store.StoreID === StoreID
          )
        ) {
          filteredVendors.push({
            key: data._id,
            ...party,
          });
        }
      });

      return {
        totalItemsCount:
          response &&
          response.hasOwnProperty("data") &&
          response.data &&
          response.data.hasOwnProperty("totalCount")
            ? response.data.totalCount
            : 0,
        searchResult: filteredVendors,
      };
    } catch (error) {
      if (
        error &&
        error.hasOwnProperty("response") &&
        error.response &&
        error.response.hasOwnProperty("data")
      ) {
        throw error.response.data;
      }

      throw error;
    }
  };
}

